import script from "./AdminOffers.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOffers.vue?vue&type=script&setup=true&lang=js"

import "./AdminOffers.vue?vue&type=style&index=0&id=133ef7f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-133ef7f6"]])

export default __exports__